import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './style.scss';

export default ({ title }) => (
    <Row xs={1}>
        <Col className={'zt-feed-title d-flex justify-content-center align-items-end'}>
            <h4>{title}</h4>
        </Col>
    </Row>);